import { combineReducers } from 'redux'
import {
  COMPLAINT_PAGE_ERROR, COMPLAINT_PAGE_LOADING, COMPLAINT_PAGE_SUCCESS, 
  COMPLAINT_ADD_ERROR, COMPLAINT_ADD_LOADING, COMPLAINT_ADD_SUCCESS, 
  COMPLAINT_VIEW_ERROR, COMPLAINT_VIEW_LOADING, COMPLAINT_VIEW_SUCCESS, 
  COMPLAINT_DELETE_ERROR, COMPLAINT_DELETE_LOADING, COMPLAINT_DELETE_SUCCESS, 
  COMPLAINT_UPDATE_LOADING, COMPLAINT_UPDATE_SUCCESS, COMPLAINT_UPDATE_ERROR, 
  COMPLAINT_REPLY_LIST_ERROR, COMPLAINT_REPLY_LIST_LOADING, COMPLAINT_REPLY_LIST_SUCCESS, 
  COMPLAINT_REPLY_ADD_ERROR, COMPLAINT_REPLY_ADD_LOADING, COMPLAINT_REPLY_ADD_SUCCESS, 
} from './constant'

const complaintPageError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_PAGE_ERROR:
      return action.complaintPageError
    default:
      return state
  }
}

const complaintPageLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_PAGE_LOADING:
      return action.complaintPageLoading
    default:
      return state
  }
}

const complaintPageSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_PAGE_SUCCESS:
      return action.complaintPageSuccess
    default:
      return state
  }
}

const complaints = (state = [], action) => {
  switch (action.type) {
    case COMPLAINT_PAGE_SUCCESS:
      return action.complaint
    default:
      return state
  }
}

const complaint = (state = [], action) => {
  switch (action.type) {
    case COMPLAINT_VIEW_SUCCESS:
      return action.complaint
    default:
      return state
  }
}

const complaintAddError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_ADD_ERROR:
      return action.complaintAddError
    default:
      return state
  }
}

const complaintAddLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_ADD_LOADING:
      return action.complaintAddLoading
    default:
      return state
  }
}

const complaintAddSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_ADD_SUCCESS:
      return action.complaintAddSuccess
    default:
      return state
  }
}

const complaintViewError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_VIEW_ERROR:
      return action.complaintViewError
    default:
      return state
  }
}

const complaintViewLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_VIEW_LOADING:
      return action.complaintViewLoading
    default:
      return state
  }
}

const complaintViewSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_VIEW_SUCCESS:
      return action.complaintViewSuccess
    default:
      return state
  }
}

const complaintDeleteError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_DELETE_ERROR:
      return action.complaintDeleteError
    default:
      return state
  }
}

const complaintDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_DELETE_LOADING:
      return action.complaintDeleteLoading
    default:
      return state
  }
}

const complaintDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_DELETE_SUCCESS:
      return action.complaintDeleteSuccess
    default:
      return state
  }
}

const complaintUpdateError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_UPDATE_ERROR:
      return action.complaintUpdateError
    default:
      return state
  }
}

const complaintUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_UPDATE_LOADING:
      return action.complaintUpdateLoading
    default:
      return state
  }
}

const complaintUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_UPDATE_SUCCESS:
      return action.complaintUpdateSuccess
    default:
      return state
  }
}

const complaintReplyListError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_LIST_ERROR:
      return action.complaintReplyListError
    default:
      return state
  }
}

const complaintReplyListLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_LIST_LOADING:
      return action.complaintReplyListLoading
    default:
      return state
  }
}

const complaintReplyListSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_LIST_SUCCESS:
      return action.complaintReplyListSuccess
    default:
      return state
  }
}

const complaintReplies = (state = [], action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_LIST_SUCCESS:
      return action.complaintReplies
    default:
      return state
  }
}

const complaintReplyAddError = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_ADD_ERROR:
      return action.complaintReplyAddError
    default:
      return state
  }
}

const complaintReplyAddLoading = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_ADD_LOADING:
      return action.complaintReplyAddLoading
    default:
      return state
  }
}

const complaintReplyAddSuccess = (state = false, action) => {
  switch (action.type) {
    case COMPLAINT_REPLY_ADD_SUCCESS:
      return action.complaintReplyAddSuccess
    default:
      return state
  }
}

const complaintReducer = combineReducers({
  complaintReplyListError,
  complaintReplyListLoading,
  complaintReplyListSuccess,
  complaintReplies,

  complaintReplyAddError,
  complaintReplyAddLoading,
  complaintReplyAddSuccess,

  complaintPageError,
  complaintPageLoading,
  complaintPageSuccess,

  complaints,
  complaint,

  complaintAddError,
  complaintAddLoading,
  complaintAddSuccess,

  complaintViewError,
  complaintViewLoading,
  complaintViewSuccess,

  complaintDeleteError,
  complaintDeleteLoading,
  complaintDeleteSuccess,

  complaintUpdateError,
  complaintUpdateLoading,
  complaintUpdateSuccess
})

export default complaintReducer
